import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Tooltip } from '@material-ui/core'
import InfoIcon from '@material-ui/icons/Info'
import { COLORES } from '../../../../config/colores'
import CantidadProductosPorCereal from '../reporteCamiones/CantidadProductosPorCereal'
import InfoCantidadAdicional from '../reporteCamiones/InfoCantidadAdicional'
import DetalleProductosCondicionales from './DetalleProductosCondicionales'
import TablaCamionesCalados from '../../../Camiones/containers/listados/camionesCalados/containers/TablaCamionesCalados'
import InfoAutodescargables from '../reporteCamiones/InfoAutodescargables'

export default function DetalleEstadoPlayaCalado (props) {
  const {
    productosPorCereal,
    totalProductos,
    cantidadPendientes,
    productosPendientes,
    calificacionProductos,
    autodescargables,
    soloDetalle = false
  } = props

  const detalleProductos = () => {
    if (calificacionProductos.length > 0) {
      return (
        <div>
          <Tooltip title={<>
            <h6>Productos condicionales</h6>
            { calificacionProductos.map((c, i) => {
              return (
                <div key={i}>
                  <b>{c.cereal}</b> - {c.calificacion} | {c.estadoAutorizacion} : <b>{c.cantidad}</b>
                </div>
              )
            })}
          </>
          }
          >

            <InfoIcon style={{ color: COLORES.grey.dark, margin: '0 8px' }} />
          </Tooltip>
        </div>
      )
    } else {
      return null
    }
  }

  const contenidoAutodescargables = () => {
    const filtroInicial = [
      {
        name: 'autodescargable',
        filterList: ['Si']
      },
      {
        name: 'estadoAutorizacion',
        filterList: ['Autorizado']
      }
    ]
    return <TablaCamionesCalados filtroInicial={filtroInicial} />
  }

  return (
    <Row style={{ alignItems: 'center' }}>
      {!soloDetalle
        ? <Col md={12}>
          <CantidadProductosPorCereal
            productosPorCereal={productosPorCereal}
            titulo='Productos calados'
            tituloTotal='Camiones calados'
            totalProductos={totalProductos}
            detalleProductos={detalleProductos}
          />
        </Col>
        : <Col md={6}>
          <DetalleProductosCondicionales
            detalleProductos={detalleProductos}
            totalProductos={totalProductos}
            tituloTotal='Camiones calados'
          />
        </Col>
      }

      <Col md={soloDetalle ? 6 : 12}>
        <InfoCantidadAdicional
          productos={productosPendientes}
          titulo='Cargas pendientes'
          cantidad={cantidadPendientes}
        />
      </Col>
      { autodescargables &&
        <Col md={soloDetalle ? 6 : 12}>
          <InfoAutodescargables
            productos={autodescargables}
            contenido={contenidoAutodescargables}
            titulo='Camiones autodescargables con calado aceptado'
          />
        </Col>
      }
    </Row>
  )
}
